<template>
  <div class="menuPage">
    <div id="menu">
      <ul id="nav">
        <template v-for="menu in orderedMenu">
          <li v-if="habilitarGrupo(menu)" @click="nextPage(menu)">
            <div class="link">
              {{ changeNames(menu.name) }}
              <v-icon
                style="color: #000000; font-size: 20px"
                v-if="menu.children"
                >mdi-chevron-down</v-icon
              >
            </div>

            <div class="nivel2">
              <ul>
                <template v-for="nivel2 in menu.children">
                  <li
                    v-if="temPermissao(nivel2) && habilitarGrupo(nivel2)"
                    @click="nextPage(nivel2)"
                  >
                    <div class="link">
                      {{ changeNames(nivel2.name) }}
                      <v-icon
                        style="color: #000000; font-size: 20px"
                        v-if="nivel2.children"
                        >mdi-chevron-right</v-icon
                      >
                    </div>
                    <div class="nivel3">
                      <ul>
                        <template v-for="nivel3 in nivel2.children">
                          <li
                            @click="nextPage(nivel3)"
                            v-if="temPermissao(nivel3)"
                          >
                            <div class="link">
                              {{ changeNames(nivel3.name) }}
                            </div>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <v-menu
      :close-on-content-click="false"
      open-on-hover
      :nudge-width="'auto'"
      left
      class="v-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          style="background: transparent"
          depressed
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="white">mdi-account-circle</v-icon>
        </v-btn>
      </template>

      <v-card class="card-menu">
        <v-list class="list-menu">
          <v-list-item>
            <v-list-item-avatar>
              <img
                src="https://slide1-images.s3.us-east-1.amazonaws.com/public/assets/userAsset.jpg"
                :alt="user && user.nome"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ user && user.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{
                user && user.grupo.nome
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list class="list-menu" color="white">
          <a
            href="https://slide1-manuais.s3.amazonaws.com/public/Manual+do+Usu%C3%A1rio+-+Selo.pdf"
            download="Manual do Usuário"
            target="_blank"
            class="help list-item-menu"
            v-if="isSala"
          >
            <v-icon color="#5c8bb9" class="icon-help">mdi-download </v-icon>
            Manual</a
          >
          <v-list-item
            class="list-item-menu"
            to="/usuario/atualizar-senha"
            v-if="!isSP"
          >
            <v-list-item-title class="list-item-title-menu"
              >Alterar senha</v-list-item-title
            >
          </v-list-item>

          <v-list-item class="list-item-menu" @click="$emit('logout')">
            <v-list-item-title class="list-item-title-menu"
              >Sair</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { menu } from "./constants";
import SeloLogo from "@/modules/seloLogo/seloLogo.vue";
import { compare } from "../../helpers/orderByAsc";
import { isSP } from "../../helpers/utils";

export default {
  name: "Menu",
  components: {
    SeloLogo,
  },
  props: {},
  data() {
    return {
      panel: 0,
      drawer: false,
      menus: menu || [],
      userRelatorios:
        JSON.parse(localStorage.getItem("user")).grupo.relatorioAdm || [],
    };
  },
  computed: {
    isSP() {
      return isSP;
    },
    ...mapGetters([
      "isSala",
      "isAT",
      "isParceiro",
      "isFullAdmin",
      "groupsConfig",
      "config",
      "logo",
      "isGov",
      "user",
    ]),

    orderedMenu() {
      return this.menus.map((n1) => ({
        ...n1,
        children: this.orderBy(
          n1.children
            ? n1.children.map((n2) => ({
                ...n2,
                children: this.orderBy(n2.children),
              }))
            : n1.children
        ),
      }));
    },
  },

  methods: {
    addUser(link) {
      return link.replace("userId", this.user.usuarioId);
    },
    nextPage(menu) {
      if (!menu.link || this.$route.path == menu.link) return;
      this.$router.push(this.addUser(menu.link));
    },
    habilitarGrupo(grupo) {
      if (!grupo.children || grupo.children.length === 0) {
        return this.temPermissao(grupo);
      }
      return grupo.children.some((child) => this.habilitarGrupo(child));
    },
    orderBy(array) {
      if (!array) return;
      if (array.length == 0) return;
      return array.sort((a, b) => compare(a, b, "name"));
    },
    temPermissao(menu) {
      if (this.isFullAdmin) return true;
      if (menu.config == "isFullAdmin" && this.isFullAdmin) return true;
      if (!menu.config) return true;
      this.groupsConfig[menu.config];

      if (this.groupsConfig[menu.configPai] && this.config[menu.configPai]) {
        if (this.groupsConfig[menu.config] && this.config[menu.config]) {
          return true;
        }
      } else if (this.groupsConfig[menu.config] && this.config[menu.config]) {
        return true;
      }

      return false;
    },
    changeNames(name) {
      if (this.isGov) {
        name = name.replace("Município", "Projeto");
        return name;
      }

      if (this.isSala) {
        name = name.replace("Município", "Sala");
        return name;
      }

      if (this.isParceiro) {
        name = name.replace("Município", "Parceiro");
        return name;
      }

      if (this.isAT) {
        name = name
          .replace("Meus Encontros", "Minhas Agendas")
          .replace("Encontros", "Agendas");
        return name;
      }

      return name;
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.help {
  color: rgb(0 0 0 / 66%) !important;
  width: 100%;
  padding: 15px 5px;
  display: block;
}

.menuPage {
  justify-content: space-between;
  width: 100%;
  display: flex;

  .menus {
    background: var(--corPrimaria) !important;
    color: #fff !important;
  }

  .v-list-item--link:before {
    background-color: inherit;
  }
  .v-list-item {
    color: #fff !important;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #c9c7c7;
    margin-top: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .v-application ul {
    padding-left: 0;
  }
}

.v-menu {
  margin-left: auto;
}
.list-item-menu:hover {
  background-color: #2d6189;
  color: #fff !important;
}

.list-item-menu {
  background-color: #fff;
}
</style>
<style lang="scss">
#menu {
  border: none;
  border: 0px;
  margin: 0px;
  padding: 0px;
  font-size: 18px;
  margin: auto;
}

#nav {
  height: 35px;
  list-style: none;
  margin: 0;
  padding: 0;
  float: left;
  text-align: center;
}

#nav li {
  display: inline-block;
  position: relative;
  background: transparent;
  cursor: pointer;
}

#nav li .link {
  display: flex;
  width: max-content;
  line-height: 35px;
  padding: 0 !important;
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  margin: 0 20px;
}

#nav li li {
  float: left;
  background: #484646;
  padding: 10px 0;
  width: 250px !important;
}

#nav li li .link {
  display: block;
  font-size: 14px;
  text-align: left;
  padding: 0 30px;
  z-index: 1;
  position: relative;
  color: #000000;
}

/*--- Sublist Styles ---*/
#nav > li .nivel2,
.nivel3 {
  position: absolute;
  padding: 0px;
  left: -68px;
  display: none;
}

#nav > li .nivel2 {
  max-height: 80vh;
}

/*--- Hide Sub Sublists ---*/
#nav li:hover ul .nivel3 {
  display: none;
  max-height: calc(70vh - 100px);
  overflow: auto;
}

#nav li:hover li:hover {
  background: #2d6189 !important;

  .link {
    color: #fff;
  }

  .nivel3 li {
    .link {
      color: #5c5a5a;
    }

    &:hover {
      .link {
        color: #fff !important;
      }
    }
  }
}

#nav li:hover li:first-of-type {
  margin-top: 5px;
}

/*--- Sublevel UL's display and position on hover ---*/
#nav li:hover .nivel2,
#nav li:hover .nivel3 {
  display: block;

  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  ul {
    padding-left: 0;
  }

  li {
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #5c5a5a40;
  }
}

#nav li:hover li:first-of-type {
  margin-top: 10px;
  border-radius: 4px 4px 0px 0px;
}

#nav > li:hover .nivel2 > ul > li {
  &:before {
    content: "";
    width: 20px;
    display: block;
    height: 20px;
    background: #fff;
    transform: rotate(45deg);
    position: absolute;
    right: 50%;
    z-index: -1;
    top: -5px;
  }
}

#nav li li:hover .nivel3 {
  right: -251px;
  left: unset;
  margin-top: -45px;
  display: block;
  z-index: 9999;

  ul {
    width: 100%;
    display: flex;
    flex-direction: column;

    li {
      margin-top: 0px !important;
    }
  }
}

#nav li:hover li:last-of-type {
  border-radius: 0px 0px 4px 4px;
}

#nav li:hover li:first-of-type:last-of-type {
  margin-top: 10px;
  border-radius: 4px 4px;
}

.nivel3 {
  width: max-content;
}
</style>
